export const VIEWPORT_BROWSER_WARMUP_SHARED_BUDGET_MARKER = 'KAIROS_VIEWPORT_BROWSER_WARMUP_SHARED_BUDGET';
export const VIEWPORT_BROWSER_WARMUP_CANDIDATE_LIMIT = 1500;

export const shouldOwnViewportBrowserWarmup = ({ isActiveViewport = false, isViewportMaximized = false } = {}) => (
  Boolean(isActiveViewport || isViewportMaximized)
);

export const buildViewportBrowserWarmupSlices = (
  maxSlice,
  centerSlice,
  candidateLimit = VIEWPORT_BROWSER_WARMUP_CANDIDATE_LIMIT,
) => {
  const safeMax = Math.max(0, Math.floor(Number(maxSlice) || 0));
  const center = Math.max(0, Math.min(safeMax, Math.round(Number(centerSlice) || 0)));
  const limit = Math.max(0, Math.floor(Number(candidateLimit) || 0));
  const seen = new Set([center]);
  const slices = [];
  const pushSlice = (value) => {
    if (slices.length >= limit) return;
    const slice = Math.max(0, Math.min(safeMax, Math.round(Number(value) || 0)));
    if (seen.has(slice)) return;
    seen.add(slice);
    slices.push(slice);
  };
  if (safeMax > limit && limit > 0) {
    if (limit === 1) {
      pushSlice(center === 0 ? safeMax : 0);
    } else {
      for (let sample = 0; sample < limit && slices.length < limit; sample += 1) {
        pushSlice((sample * safeMax) / (limit - 1));
      }
      for (let distance = 1; slices.length < limit && distance <= safeMax; distance += 1) {
        pushSlice(center - distance);
        pushSlice(center + distance);
      }
    }
    return { center, slices };
  }
  for (const stride of [16, 8, 4, 2, 1]) {
    for (let slice = 0; slice <= safeMax && slices.length < limit; slice += stride) pushSlice(slice);
    pushSlice(safeMax);
  }
  return { center, slices };
};

export const createViewportBrowserWarmupCandidates = ({
  maxSlice,
  centerSlice,
  buildUrl,
} = {}) => {
  if (typeof buildUrl !== 'function') return [];
  const { center, slices } = buildViewportBrowserWarmupSlices(maxSlice, centerSlice);
  const boundedSlices = slices.slice(0, VIEWPORT_BROWSER_WARMUP_CANDIDATE_LIMIT);
  return boundedSlices.map((slice, order) => ({
    slice,
    url: String(buildUrl(slice) || ''),
    distance: Math.abs(slice - center),
    order,
  })).filter(candidate => candidate.url);
};
